<template>
    <v-badge v-if="transactionIcon && badgeIcon" :icon="badgeIcon" color="accent">
        <v-icon :color="color" :size="size ? size : '25'">{{ transactionIcon }}</v-icon>
    </v-badge>
    <v-badge v-else-if="badgeIcon" :icon="badgeIcon" color="accent">
        <v-icon :color="color" v-if="transaction.paidWithCash" :size="size ? size : '25'">mdi-cash-100</v-icon>
        <v-icon :color="color" v-else-if="isTrialing" :size="size ? size : '25'">mdi-timer-sand</v-icon>
        <v-icon :color="color" v-else-if="transaction.processedBy == 'tablet'"
            :size="size ? size : '25'">mdi-tablet</v-icon>
        <v-icon :color="color" v-else-if="isDesktopTransaction(transaction)"
            :size="size ? size : '25'">mdi-monitor</v-icon>
        <v-icon :color="color" v-else-if="transaction.processedBy == 'public'"
            :size="size ? size : '25'">mdi-earth</v-icon>
        <v-icon :color="color" v-else-if="transaction.processedBy == 'terminal'"
            :size="size ? size : '25'">mdi-calculator</v-icon>
        <v-icon :color="color" v-else :size="size ? size : '25'">mdi-cellphone</v-icon>
    </v-badge>
    <v-icon :color="color" v-else-if="transaction.paidWithCash" :size="size ? size : '25'">mdi-cash-100</v-icon>
    <v-icon :color="color" v-else-if="isTrialing" :size="size ? size : '25'">mdi-timer-sand</v-icon>
    <v-icon :color="color" v-else-if="transaction.processedBy == 'tablet'"
        :size="size ? size : '25'">mdi-tablet</v-icon>
    <v-icon :color="color" v-else-if="isDesktopTransaction(transaction)" :size="size ? size : '25'">mdi-monitor</v-icon>
    <v-icon :color="color" v-else-if="transaction.processedBy == 'public'" :size="size ? size : '25'">mdi-earth</v-icon>
    <v-icon :color="color" v-else-if="transaction.processedBy == 'terminal'"
        :size="size ? size : '25'">mdi-calculator</v-icon>
    <v-icon :color="color" v-else :size="size ? size : '25'">mdi-cellphone</v-icon>
</template>

<script>
export default {
    data() {
        return {
            color: 'gray',
            badgeIcon: null,
            transactionIcon: null,
            isTrialing: false
        }
    },
    props: [
        'transaction',
        'statusColor',
        'size'
    ],
    created() {
        if (this.statusColor) {
            this.color = this.statusColor;
        } else if (this.transaction.cancelled) {
            this.color = this.themeColor('error');
        } else if (this.transaction.expired) {
            this.color = this.themeColor('error');
        } else if (this.transaction.completed) {
            if (this.transaction.subscriptionStartDate) {
                const now = new Date();
                const subscriptionStartDate = new Date(this.transaction.subscriptionStartDate);
                if (now < subscriptionStartDate) {
                    this.color = this.themeColor('yellow');
                    this.isTrialing = true;
                } else {
                    this.color = this.themeColor('success');
                }
            } else {
                this.color = this.themeColor('success');
            }
        } else {
            this.color = this.themeColor('error');
        }
        //We need to make sure that if it has stripe data we are not skipping the past_due cases
        if (!this.statusColor && this.transaction.subscription && (this.transaction.subscription.status != 'active' && this.transaction.subscription.status != 'trialing')) {
            this.color = this.themeColor('error');
        }
        if (this.transaction.paymentsModule == 'easypay') {
            if (this.transaction.subscriptionStartDate) {
                const now = new Date();
                const futureDate = new Date(this.transaction.subscriptionStartDate);
                futureDate.setHours(now.getHours());
                if (futureDate > now)
                    this.badgeIcon = 'mdi-timer-sand';
            } else if (this.transaction.recurrence && this.transaction.recurrence.interval) {
                this.badgeIcon = 'mdi-sync';
            }
        } else if (this.transaction.subscription) {
            this.badgeIcon = 'mdi-sync';
        } else if (!this.transaction.cancelled && !this.transaction.completed && this.transaction.status == 'pending_payment') {
            this.badgeIcon = 'mdi-email-fast-outline';
        }
        //else -> process regular ones the new way with badges
    }
}
</script>
